'use client';

import React, { useState } from 'react';
import { AddToListModal } from 'src/components/AddToListModal';
import { useProspectSelection } from 'src/context/prospects';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { faCirclePlus } from '@fortawesome/pro-solid-svg-icons';

const RoundAddToListButton = ({ onClearSelection }) => {
  const {
    state: [newProviders],
    selectedRows: [rowsAreSelected, setRowsAreSelected],
  } = useProspectSelection();

  const [showAddProvidersDialog, setShowAddProvidersDialog] = useState(false);

  return (
    <>
      <button
        type="button"
        className={`h-9 w-9 p-2 rounded-full outline outline-1 -outline-offset-1 inline-flex justify-center items-center gap-2.5 ${
          newProviders?.length > 0
            ? 'outline-sky-100 hover:outline-neutral-300 hover:bg-neutral-50 cursor-pointer'
            : 'outline-neutral-100 opacity-50 cursor-not-allowed'
        }`}
        onClick={() => setShowAddProvidersDialog(true)}
        data-testid="round-add-to-list-button"
        disabled={!newProviders?.length}
      >
        <div
          data-size="sm"
          className="w-5 h-5 flex items-center justify-center"
        >
          <Icon
            icon={faCirclePlus}
            className={`w-4 h-4 ${
              newProviders?.length > 0 ? 'text-sky-600' : 'text-neutral-200'
            }`}
          />
        </div>
      </button>
      <AddToListModal
        isOpen={showAddProvidersDialog}
        onClose={() => {
          setRowsAreSelected(!rowsAreSelected);
          setShowAddProvidersDialog(false);
          if (onClearSelection) {
            onClearSelection();
          }
        }}
        mode="add"
        providers={newProviders || []}
      />
    </>
  );
};

export default RoundAddToListButton;
